<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style >
.el-card__body {
  padding: 16px 10px;
}
</style>
  <style >

.app-container {
  min-height: 110%;
  background: rgba(242, 242, 242, 1);
  /* background: red; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue